import React from 'react';
import { USER_EMAIL } from 'reactApp/appHelpers/configHelpers';
import { computersGenitive } from 'reactApp/utils/pluralHelpers';

import styles from './MultiSessionFeaturesList.css';

const featuresList: Array<string> = [
    '1 ТБ для писем и файлов',
    'Без рекламы в Почте и Облаке',
    'Красивый адрес почты',
    'Нейропомощник в\u00A0Почте',
    'Краткий пересказ писем',
    'Отправка вложений до\u00A0100\u00A0ГБ\u00A0в\u00A0письмах',
    'Отмена отправки писем в\u00A0течение 30\u00A0секунд',
];

export const MultiSessionFeaturesList = ({ deviceCount }: { deviceCount: number }) => {
    const list = [`Вход в\u00A0аккаунт ${USER_EMAIL} с\u00A0${deviceCount}\u00A0${computersGenitive(deviceCount)} `, ...featuresList];
    return (
        <div className={styles.root}>
            {list.map((feature, index) => (
                <li key={`${index}-${feature}`} className={styles.item}>
                    {feature}
                </li>
            ))}
        </div>
    );
};
